import { BlockedUserIdType } from '@exam-center/graphql';
import { zodResolver, type PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import { BlockedUserCreationSchema, type BlockedUserCreationFormType } from './schema';

type BlockedUserCreationFormProviderProps = PropsWithChildren;

export default function BlockedUserCreationFormProvider(
  props: Readonly<BlockedUserCreationFormProviderProps>,
) {
  const { children } = props;

  const formContext = useForm<BlockedUserCreationFormType>({
    defaultValues: {
      personal: {
        idType: BlockedUserIdType.CitizenCard,
        idNumber: '',
        title: null,
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
      },
      blocklistInfo: {
        blockedAt: null,
        blockedType: null,
        position: '',
        department: '',
        reason: '',
        enforcementEnd: {
          assign: undefined,
        },
        blockedCourses: {
          type: undefined,
          courses: undefined,
        },
      },
    },
    resolver: zodResolver(BlockedUserCreationSchema),
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
